import mapActions from './mapActions';

export default mapActions('building_equipment', {
    fetchAll_url: (data) => `/api/buildings/${data.building_id}/equipment`,
    fetchConcrete: (id) => `/api/building_equipment/${id}`,
});
